import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=56e315c8&scoped=true&"
import script from "./Photography.vue?vue&type=script&lang=js&"
export * from "./Photography.vue?vue&type=script&lang=js&"
import style0 from "./Photography.vue?vue&type=style&index=0&id=56e315c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e315c8",
  null
  
)

export default component.exports